import { initial } from 'lodash';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Segment, Dimmer, Checkbox, Container, Grid, Button, Header, Divider, Form, Menu, Message, Modal, Loader } from 'semantic-ui-react';
import { FormSongVersion } from '../forms/FormSongVersion';

const emptyData = {profile: {
  first_name: "",
  last_name: "",
  gender: "",
  ethnicity: "",
  birth_date: "",
  death_date: "",
  blurb: "",
  image_url: "",
  website_url: "",
  biography_url: ""
}}; 

export const EditComposer = ({ openButton, onSuccess, initialData, spinnerActive, displayError }) => {

  const [ modalOpen, setModalOpen ] = useState(false);
  const [ data, setData ] = useState(emptyData);

  useEffect(() => {
    if (initialData) {
        setData(JSON.parse(JSON.stringify(initialData)));
    }
  }, [initialData]);

  const inputHandler = (e, { name, value }) => {
    setData((old) => {
      const newProfile = {...data.profile};
      newProfile[name] = value;
      const newData = {};
      newData.profile = newProfile;
      return {...old, ...newData};
    });
  }

  const headertext = initialData ? "Edit Composer" : "New Composer";
  const header = <Header as='h3' color='purple' className='subtitle'>{headertext}</Header>

  const handleSubmit = () => { onSuccess(data, () => {setModalOpen(false)}) };
  //ethnicity field removed from form <Form.Input fluid name="ethnicity" label='Ethnicity' value={data.profile.ethnicity} onChange={inputHandler}/>
  return (
    <Modal size='large' trigger={openButton} dimmer={spinnerActive} open={modalOpen} onClose={() => setModalOpen(false)}
    onOpen={() => setModalOpen(true)}>
      <Modal.Header>
        {header}
      </Modal.Header> 
      <Modal.Content scrolling>
        <Form>
          <Form.Group widths="equal">
            <Form.Input fluid name="first_name" label='First Name' value={data.profile.first_name} onChange={inputHandler}/>
            <Form.Input fluid name="last_name" label='Last Name' value={data.profile.last_name} onChange={inputHandler}/>
            <Form.Input fluid name="gender" label='Gender' value={data.profile.gender} onChange={inputHandler}/> 
          </Form.Group>


          <Form.Group widths="equal">
            <Form.Input fluid name="birth_date" label='Birth Date' value={data.profile.birth_date} onChange={inputHandler}/>
            <Form.Input fluid name="death_date" label='Date of Death' value={data.profile.death_date} onChange={inputHandler}/>
          </Form.Group>
          Time format YYYY-MM-DD "1948-12-31"

         {/* <Form.TextArea rows="8" name='blurb' label="Biography" value={data.profile.blurb} onChange={inputHandler}/> */}

          <Form.Group widths="equal">
            <Form.Input fluid name="image_url" label='Image URL' value={data.profile.image_url} onChange={inputHandler}/>
            <Form.Input fluid name="website_url" label='Website URL' value={data.profile.website_url} onChange={inputHandler}/>
            <Form.Input fluid name="biography_url" label='Biography URL' value={data.profile.biography_url} onChange={inputHandler}/>
          </Form.Group>

        </Form>
      </Modal.Content>
      
      <Modal.Actions>
        {displayError && <div>unable to update composer</div>}
        <Button color='red' onClick={() => {setModalOpen(false);}}>Cancel</Button>
        <Button color='green' onClick={handleSubmit} loading={spinnerActive}>
          Save Changes
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
